/* RESPONSIBLE TEAM: team-app-security */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    groups: {
      serialize: 'records',
      deserialize: 'records',
    },
  },

  keyForAttribute(attr) {
    return attr;
  },
});
